"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.types12 = void 0;
const types_10_1 = require("./types_10");
exports.types12 = Object.assign(Object.assign({}, types_10_1.types10), { 
    // Staking updated types
    DelegationCounter: {
        round: "SessionIndex",
        counter: "u32",
    }, 
    // DID updated types
    DidVerificationKey: {
        _enum: {
            Ed25519: "[u8; 32]",
            Sr25519: "[u8; 32]",
            Secp256k1: "[u8; 33]",
        },
    }, DidSignature: {
        _enum: {
            Ed25519: "Ed25519Signature",
            Sr25519: "Sr25519Signature",
            "Ecdsa-Secp256k1": "EcdsaSignature",
        },
    } });
